import { httpClient, mountUrl } from '@/httpClient'

const BASE_URL = '/api/v1/domains/tlds'

export const findAll = () => httpClient.get(mountUrl(BASE_URL))
